import api from "./api";

// ... existing keywords code ...
export const fetchAiKeywords = async (chatRoomId) => {
    // ...
    // [변경] searchApi -> api (메인 서버)
    const response = await api.post(`/api/ai/keywords/${chatRoomId}`, { keywords: [] });
    let result = response.data;
    // ...
    if (typeof result === "string") {
        try {
            result = JSON.parse(result);
        } catch (e) {
            console.error("Keywords Parse Error:", e);
            result = {};
        }
    }
    if (Array.isArray(result)) return { keywords: result };
    return { keywords: Array.isArray(result?.keywords) ? result.keywords : [] };
};

export const fetchAiPlan = async (chatRoomId, keywords) => {
    // ...
    const sanitizedKeywords = Array.isArray(keywords)
        ? keywords.map((kw) => (kw === null || kw === undefined ? "" : String(kw).trim())).filter(Boolean)
        : [];
    if (!sanitizedKeywords.length) throw new Error("여행 계획을 만들 키워드가 없습니다.");
    if (chatRoomId === undefined || chatRoomId === null || !String(chatRoomId).length) {
        throw new Error("채팅방 정보(chatRoomId)가 없어 여행 계획을 생성할 수 없습니다.");
    }

    console.log("🚀 [AI Plan 요청] chatRoomId:", chatRoomId, "키워드:", sanitizedKeywords);

    const response = await api.post("/api/ai/plan", { chatRoomId, keywords: sanitizedKeywords });
    let result = response.data;

    // Parsing logic ...
    if (typeof result === "string") {
        try {
            const cleanedResult = result.replace(/```json|```/g, "").trim();
            result = JSON.parse(cleanedResult);
        } catch (e) {
            result = {};
        }
    }
    const root = result?.data ?? result?.result ?? result ?? {};
    let title = root.title;
    let description = root.description;
    let schedule = root.schedule;
    if (!schedule && root.data) {
        title = root.data.title ?? title;
        description = root.data.description ?? description;
        schedule = root.data.schedule;
    }
    if (typeof schedule === "string") {
        try {
            schedule = JSON.parse(schedule);
        } catch (e) {
            schedule = [];
        }
    }
    const finalSchedule = Array.isArray(schedule) ? schedule : [];
    return { title, description, schedule: finalSchedule };
};

/**
 * 여행 계획 확정 저장
 * POST /api/ai/plan/confirm
 */
export const confirmAiPlan = async (planData) => {
    try {
        const response = await api.post("/api/ai/plan/confirm", planData);
        return response.data; // { id: "plan_id", ... }
    } catch (error) {
        console.error("Failed to confirm plan:", error);
        throw error;
    }
};

/**
 * 내 여행 계획 목록 조회
 * GET /api/ai/plans
 */
export const getMyPlans = async (chatRoomId) => {
    try {
        const params = chatRoomId !== undefined && chatRoomId !== null && String(chatRoomId).length
            ? { chatRoomId }
            : undefined;
        const response = await api.get("/api/ai/plans", params ? { params } : undefined);
        return response.data; // Array of plans
    } catch (error) {
        console.error("Failed to fetch my plans:", error);
        throw error;
    }
};

/**
 * 여행 계획 수정 (체크/완료/삭제 반영)
 * PUT /api/ai/plan/{planId}
 */
export const updateAiPlan = async (planId, updatedPlanData) => {
    try {
        const response = await api.put(`/api/ai/plan/${planId}`, updatedPlanData);
        return response.data;
    } catch (error) {
        console.error("Failed to update plan:", error);
        throw error;
    }
};

/**
 * 여행 계획 삭제
 * DELETE /api/ai/plan/{planId}
 */
export const deleteAiPlan = async (planId) => {
    try {
        const response = await api.delete(`/api/ai/plan/${planId}`);
        return response.data;
    } catch (error) {
        console.error("Failed to delete plan:", error);
        throw error;
    }
};
